import styled from "styled-components";
import fipayFont from "../../../../theme/index";
import { colors } from "../../../../theme/color";

export const ContentWrapperCon = styled.div`
  background-color: #f7f7f7;
  padding: 10px 10px;
  margin-top: 10px;
  @media only screen and (max-width: 767px) {
    padding: 10px 10px;
    margin-top: 5px;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
  }
`;

export const SecondContWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media only screen and (max-width: 767px) {
    display: flex;
    flex-direction: column;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const PaymentLinkHeader = styled.div`
  width: 40%;
  @media only screen and (max-width: 767px) {
    width: 100%;
    gap: 0.31rem;
    display: flex;
    flex-direction: column;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
  }
`;

export const HelloSpan = styled.div`
  color: #5e5e5e;
`;
export const Name = styled.span`
  margin-bottom: 2px;
  @media only screen and (max-width: 768px) {
    font-size: 20px;
  }

  @media only screen and (max-width: 1024px) {
    font-size: 20px;
  }

  @media only screen and (max-width: 320px) {
    font-size: 18px;
    padding-top: 2px;
  }
`;

export const PaymentLinkHeaderText = styled.h1`
  display: flex;
  height: 32px;
  color: ${colors.NAVYBLUE};
  font-size: ${fipayFont.fipayFonts.fontSize.heading3};
  font-weight: ${fipayFont.fipayFonts.fontWeight.medium};
  gap: 5px;
  line-height: 32px;
  /* border: 2px solid red; */
`;

export const PaymentLinkHeaderBeneathText = styled.p`
  margin-top: -18px;
  color: ${colors.DARK_GRAY};
  font-size: ${fipayFont.fipayFonts.fontSize.body3};
  font-weight: ${fipayFont.fipayFonts.fontWeight.regular};
  line-height: 24px;
`;

export const PaymentLinkButtonContainer = styled.div`
  padding-top: 30px;
  width: 30%;
  display: flex;
  flex-direction: row;
  gap: 10px;
  @media only screen and (max-width: 767px) {
    width: 100%;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    width: 100%;
  }
`;
